(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/draw-card/assets/javascripts/draw-card-variants/draw-card-horizontal-list-item.js') >= 0) return;  svs.modules.push('/components/tipsen/draw-card/assets/javascripts/draw-card-variants/draw-card-horizontal-list-item.js');
"use strict";


const clx = svs.components.lbUtils.clx;
const _svs$components$tipse = svs.components.tipsen.drawCard,
  DrawCard = _svs$components$tipse.DrawCard,
  useConditionalWrapper = _svs$components$tipse.useConditionalWrapper;
const _svs$components$tipse2 = svs.components.tipsen.drawCard.constants,
  DRAW_CARD_LAYOUTS = _svs$components$tipse2.DRAW_CARD_LAYOUTS,
  DRAW_CARD_ICON_SIZE = _svs$components$tipse2.DRAW_CARD_ICON_SIZE,
  DRAW_STATE = _svs$components$tipse2.DRAW_STATE,
  DRAW_STATE_TEXTS = _svs$components$tipse2.DRAW_STATE_TEXTS,
  DRAW_CARD_TITLES = _svs$components$tipse2.DRAW_CARD_TITLES;
const _svs$components$tipse3 = svs.components.tipsen.drawCard.components,
  DisabledOverlay = _svs$components$tipse3.DisabledOverlay,
  DrawCardPanel = _svs$components$tipse3.DrawCardPanel;
const _svs$ui$ReactSpeechBu = svs.ui.ReactSpeechBubble,
  SpeechBubble = _svs$ui$ReactSpeechBu.SpeechBubble,
  SpeechBubbleSport3 = _svs$ui$ReactSpeechBu.SpeechBubbleSport3;
const currencyFromJupiterString = svs.utils.format.CurrencyFromJupiterString;
const formatDate = svs.components.lbUtils.helpers.formatDate.formatDate;
const DrawCardHorizontalListItemPanel = _ref => {
  let children = _ref.children,
    className = _ref.className,
    ariaLabel = _ref.ariaLabel;
  return React.createElement("div", {
    "aria-label": ariaLabel,
    className: "pg_draw_card_horizontal_list_item__panel ".concat(className || '').trim()
  }, children);
};
const DisabledOverlayWrapper = _ref2 => {
  let children = _ref2.children;
  return React.createElement(DisabledOverlay, {
    isHorizontal: true
  }, children);
};
const DrawCardHorizontalListItem = _ref3 => {
  var _renderDate$charAt;
  let betEvents = _ref3.betEvents,
    branding = _ref3.branding,
    className = _ref3.className,
    competitionDrawNumber = _ref3.competitionDrawNumber,
    extraMoney = _ref3.extraMoney,
    _ref3$icon = _ref3.icon,
    icon = _ref3$icon === void 0 ? 'game-sport' : _ref3$icon,
    league = _ref3.league,
    netSale = _ref3.netSale,
    _ref3$isListItem = _ref3.isListItem,
    isListItem = _ref3$isListItem === void 0 ? false : _ref3$isListItem,
    regCloseTime = _ref3.regCloseTime,
    state = _ref3.state,
    titleElement = _ref3.titleElement,
    uniqueId = _ref3.uniqueId,
    isSelected = _ref3.isSelected;
  const blockName = 'pg_draw_card_horizontal_list_item';
  const classNames = clx(blockName, {
    'pg_draw_card--selected': isSelected,
    'pg_draw_card_horizontal_list_item--selected': isSelected
  }, className);
  const ConditionalDisabledOverlayWrapper = useConditionalWrapper(DisabledOverlayWrapper, {
    skip: state !== DRAW_STATE.TEMPORARY_CLOSED
  });
  const date = new Date(regCloseTime);
  const isValidDate = !isNaN(date);
  const renderDate = isValidDate ? formatDate(regCloseTime, true, true, false) : regCloseTime;
  const renderDataCapitalized = (renderDate === null || renderDate === void 0 || (_renderDate$charAt = renderDate.charAt(0)) === null || _renderDate$charAt === void 0 ? void 0 : _renderDate$charAt.toUpperCase()) + (renderDate === null || renderDate === void 0 ? void 0 : renderDate.slice(1));
  return React.createElement(ConditionalDisabledOverlayWrapper, null, React.createElement(DrawCard, {
    branding: branding,
    className: classNames,
    layout: DRAW_CARD_LAYOUTS.HORIZONTAL
  }, React.createElement(DrawCardHorizontalListItemPanel
  , {
    ariaLabel: "Omg\xE5ng: ".concat(titleElement).concat(competitionDrawNumber > 0 ? ", t\xE4vlingsomg\xE5ng: ".concat(competitionDrawNumber) : '').concat(extraMoney !== null && extraMoney !== void 0 && extraMoney.isExtraMoney ? ", ".concat(DRAW_CARD_TITLES.EXTRA_MONEY, ": ").concat(extraMoney.amount, " kronor") : '').concat(extraMoney !== null && extraMoney !== void 0 && extraMoney.isRolloverIn ? ", ".concat(DRAW_CARD_TITLES.ROLL_OVER_IN, ": ").concat(extraMoney.amount, " kronor") : ''),
    className: "pg_draw_card_horizontal_list_item__title"
  }, React.createElement("div", {
    "aria-hidden": true,
    className: "pg_draw_card_horizontal_list_item__title--draw_league"
  }, React.createElement(DrawCard.Title, {
    icon: icon,
    iconSize: DRAW_CARD_ICON_SIZE.SMALL,
    isSelected: isSelected
  }, titleElement), competitionDrawNumber > 0 ? React.createElement("span", {
    className: "pg_draw_card_horizontal_list_item__title__comp_nbr"
  }, "".concat(DRAW_CARD_TITLES.DRAW_DESCRIPTION, " ").concat(competitionDrawNumber)) : React.createElement("span", {
    className: "pg_draw_card_horizontal_list_item__title__league"
  }, league)), (extraMoney === null || extraMoney === void 0 ? void 0 : extraMoney.isExtraMoney) && React.createElement(SpeechBubble, {
    size: "100"
  }, React.createElement(SpeechBubbleSport3, null, "".concat(DRAW_CARD_TITLES.EXTRA_MONEY, ": ").concat(extraMoney.amount))), (extraMoney === null || extraMoney === void 0 ? void 0 : extraMoney.isRolloverIn) && React.createElement(SpeechBubble, {
    size: "100"
  }, React.createElement(SpeechBubbleSport3, null, "".concat(DRAW_CARD_TITLES.ROLL_OVER_IN, ": ").concat(extraMoney.amount)))), React.createElement(DrawCardHorizontalListItemPanel, {
    className: "pg_draw_card_horizontal_list_item__reg_close_time"
  }, state !== DRAW_STATE.CANCELLED && React.createElement(DrawCardPanel, {
    ariaLabel: state === DRAW_STATE.CANCELLED ? "".concat(DRAW_CARD_TITLES.STATE, ": ").concat(DRAW_STATE_TEXTS.CANCELLED) : "".concat(DRAW_CARD_TITLES.BET_STOP, ": ").concat(renderDataCapitalized),
    title: DRAW_CARD_TITLES.BET_STOP
  }, React.createElement(DrawCard.RegCloseTime, null, regCloseTime)), state === DRAW_STATE.CANCELLED && React.createElement(DrawCard.Status, {
    isCancelled: true
  }, DRAW_STATE_TEXTS.CANCELLED)), React.createElement(DrawCardHorizontalListItemPanel, {
    className: "pg_draw_card_horizontal_list_item__net_sale"
  }, React.createElement(DrawCardPanel, {
    ariaLabel: "".concat(DRAW_CARD_TITLES.NET_SALE, ": ").concat(currencyFromJupiterString(netSale), " kronor"),
    title: DRAW_CARD_TITLES.NET_SALE
  }, React.createElement(DrawCard.NetSale, {
    uniqueId: uniqueId
  }, netSale))), (extraMoney === null || extraMoney === void 0 ? void 0 : extraMoney.isExtraMoney) && (extraMoney === null || extraMoney === void 0 ? void 0 : extraMoney.isJackpot) && React.createElement(DrawCardHorizontalListItemPanel, {
    className: "pg_draw_card_horizontal_list_item__extra_money"
  }, React.createElement(DrawCardPanel, {
    ariaLabel: "".concat(DRAW_CARD_TITLES.JACKPOT, ": ").concat(extraMoney.amount, " kronor")
  }, React.createElement(DrawCard.ExtraAmount, null, "".concat(DRAW_CARD_TITLES.JACKPOT, ": ").concat(extraMoney.amount)))), React.createElement(DrawCardPanel, {
    className: "pg_draw_card_horizontal_list_item__bet_events",
    hasHiddenArea: !isListItem
  }, React.createElement(DrawCard.BetEvents, {
    hasScrolling: true
  }, betEvents)), React.createElement(DrawCard.DrawToggleBtn, {
    className: "pg_draw_card_horizontal_list_item__change_draw_btn",
    isSelected: isSelected
  })));
};
setGlobal('svs.components.tipsen.drawCard.DrawCardHorizontalListItem', DrawCardHorizontalListItem);

 })(window);